/**
 * Helper functions for converting between different time units.
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */

/**
 * Convert milliseconds to seconds
 * @param ms time in milliseconds
 * @returns time in seconds
 */
export function toSeconds(ms: number): number {
    return ms / 1000
}
